import React from 'react';
import {Image} from '@/components-v2/Image';
import {useMeUser} from './hooks';
import {ReactComponent as AvatarSvg} from '@/assets/icons/me/avatar.svg';
import {ReactComponent as WhiteRightArrowIcon} from '@/assets/icons/me/white-right-arrow.svg';
import {defaultHeaderImg} from '../../me.variable';

const MeTopUser = () => {
  const {login, user, heightPercent, t, toProfile} = useMeUser();

  return (
    <div
      className="fixed top-0 left-0 w-full flex flex-row px-5 justify-between items-center z-50 bg-c1 transition-[height] overflow-hidden"
      style={{height: `${(heightPercent * 56) / 16}rem`}}
      onClick={toProfile}>
      <div className="flex flex-row items-center gap-3">
        {login ? (
          <Image
            src={user?.avatar || defaultHeaderImg}
            className="size-8 !max-w-full rounded-full bg-white flex items-center justify-center"
          />
        ) : (
          <AvatarSvg className="size-8" />
        )}
        <span className="text-sm text-white">
          {login ? user?.userName : t('me.user.login')}
        </span>
      </div>
      <WhiteRightArrowIcon className="size-3.5" />
    </div>
  );
};

export default MeTopUser;
